import React, { useEffect, useState } from "react";
import {
  CellContent,
  CellContentCarbonRatioStatus,
  CellContentCte,
  CellText,
  FirstTextCte,
  HeaderContent,
  ListContainer,
  ListContent,
  ListHeader,
  StyledArrowDown,
  StyledArrowUp,
} from './styles';
import { connect } from "react-redux";
import { OrderByValue } from "../../constants/TitleOptions";
import { changeFilters, getCarbonEmissionList } from "../../../../redux/carbon";

function CarbonTable({ data, titleOptions, orderByFilter, dispatch }) {
  const [orderByState, setOrderByState] = useState(orderByFilter || []);

  useEffect(() => {
    setOrderByState(orderByFilter);
  }, [orderByFilter]);

  function formatCarbonEmission(emission) {
    return emission.toLocaleString('pt-BR', { minimumFractionDigits: 10, maximumFractionDigits: 10 });
  }

  function handleHeaderContent(propItem) {
    if (!propItem.canOrder) {
      return;
    }

    const newOrderBy = orderByState.map((item) => {
      if (item.attribute === propItem.attribute) {
        return {
          attribute: item.attribute,
          value: item.value === OrderByValue.descending ? OrderByValue.ascending : OrderByValue.descending,
        };
      }
      return item;
    });

    if (!newOrderBy.some(item => item.attribute === propItem.attribute)) {
      newOrderBy.push({
        attribute: propItem.attribute,
        value: OrderByValue.ascending,
      });
    }

    setOrderByState(newOrderBy);
    dispatch(changeFilters({ orderBy: newOrderBy }));
    dispatch(getCarbonEmissionList());
  }

  return (
    <ListContainer>
      <ListHeader>
        {titleOptions.map((item, index) => {
          const orderByItem = orderByState.find(o => o.attribute === item.attribute);
          return (
            <HeaderContent onClick={() => handleHeaderContent(item)} key={`${item.text}-${index}`}>
              {item.text}
              {item.canOrder && (
                orderByItem && orderByItem.value === OrderByValue.descending ? (
                  <StyledArrowUp />
                ) : (
                  <StyledArrowDown />
                )
              )}
            </HeaderContent>
          );
        })}
      </ListHeader>
      {data.length > 0 && (
        <>
          {data.map((value, index) => (
            <ListContent key={`${value.cte.identifier}-${index}`}>
              <CellContentCte>
                <FirstTextCte>{value.cte.identifier}</FirstTextCte>
                <CellText>{value.cte.type}</CellText>
              </CellContentCte>
              <CellContent>
                <CellText>{value.organization}</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.vehicle}</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.weight} KG</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.nameOrigin}</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.localOrigin}</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.destinationName}</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.destinationLocal}</CellText>
              </CellContent>
              <CellContent>
                <CellText>{value.distance} KM</CellText>
              </CellContent>
              <CellContentCarbonRatioStatus carbonRatioStatus={value.carbonRatioStatus}>
                <div>{formatCarbonEmission(value.carbonEmission)} <strong>T.CO2EQ.</strong></div>
              </CellContentCarbonRatioStatus>
            </ListContent>
          ))}
        </>
      )}
    </ListContainer>
  );
}

const mapStateToProps = state => ({
  orderByFilter: state.carbon.filters.orderBy,
});

export default connect(mapStateToProps)(CarbonTable);
